export default __webpack_public_path__ + "static/media/building-icon.png?.6c7f6c8a";